/*
 *  Test av fødselsnummer
 *
 *  updated 08 Feb 2021
 *  by Lars Erik Storbukås <https://github.com/storbukas>
 *
 *  Source: https://github.com/storbukas/norsk-validator
 *
 *  Licensed under the MIT License
 *  https://opensource.org/licenses/MIT
 *
 */
'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var MOD11 = 11;
var MOD10 = 10;
exports.kontrollsiffferMod11 = function (tall) {
    var kontrollsiffer = 2;
    var sum = 0;
    for (var i = tall.length - 2; i >= 0; --i) {
        sum += tall.charAt(i) * kontrollsiffer;
        kontrollsiffer += 1;
        if (kontrollsiffer > 7) {
            kontrollsiffer = 2;
        }
    }
    var result = MOD11 - (sum % MOD11);
    return result === MOD11 ? 0 : result;
};
exports.kontrollsiffferMod10 = function (tall) {
    var sum = 0;
    var dbl;
    for (var i = tall.length - 2; i >= 0; i -= 2) {
        dbl = (parseInt(tall.charAt(i), 10) * 2).toString();
        sum += parseInt(dbl.charAt(0), 10) + parseInt(dbl.charAt(1) || '0', 10);
    }
    for (var i = tall.length - 3; i >= 0; i -= 2) {
        sum += parseInt(tall.charAt(i), 10);
    }
    var sumString = sum.toString();
    return MOD10 - parseInt(sumString.charAt(sumString.length - 1), 10);
};
